{
  "(optional)": "(אופציונלי)",
  "(required)": "(נדרש)"
}
